import {
  IAppConfigs,
  ICurrentPage,
  ILanguageConfigs,
  IModuleConfigs,
  ValueOf
} from 'interfaces/generic';

type GlobalType = {
  appConfigs: IAppConfigs;
  moduleConfigs: IModuleConfigs;
  languageConfigs: ILanguageConfigs;
  currentPage: ICurrentPage;
  next: {
    wrapper: {
      firstMountId: string | null;
    };
  };
  floatingBetslipMounted: boolean;
  betslipElementsCount: number;
  // @Todo remove me
  betslipGlobalComponentRid: string;
  openBetsGlobalComponentRid: string;
  // @Todo remove me
  freebetGlobalRid: string;
  subscriptionModalMounted: boolean;
  sportsBook: {
    redirectedFromFavorite: boolean;
  };
  casino: {
    casinoElementsCount: number;
    singleGameViewMounted: boolean;
    isCasinoCategoriesMounted: boolean;
    // TODO: remove this after replacing old casino games
    gameClickOffsetTop: null | number;
    blockCasinoGamePopupOpening: boolean;
    allGamesCountFetched: boolean;
  };
  tournament: {
    cardClickOffset: number;
  };
  mounted: Record<string, boolean>;
  app: {
    messageListenerMounted: boolean;
    genericMounted: boolean;
    browserHistory?: any;
    dayjsLangImported: boolean;
    configureSpringCalled: boolean;
  };
  isTopNavigationButtonMounted: boolean;
  homeworkIframe: boolean;
  oddsFormat?: boolean;
  initProces: boolean;
  geolocationWindow?: { close: () => void } | null;
  oneTimeCommands: {
    getUserSportOrder: boolean;
  };
  account: {
    registration: {
      automaticSmsCode: boolean;
      isRecaptchaVerify: boolean;
    };
  };
};

export const GLOBALS: GlobalType = {
  appConfigs: {} as IAppConfigs,
  languageConfigs: {} as ILanguageConfigs,
  currentPage: {} as ICurrentPage,
  moduleConfigs: {} as IModuleConfigs,
  next: {
    wrapper: {
      firstMountId: null
    }
  },
  floatingBetslipMounted: false,
  betslipElementsCount: 0,
  betslipGlobalComponentRid: '',
  openBetsGlobalComponentRid: '',
  freebetGlobalRid: '',
  subscriptionModalMounted: false,
  mounted: {
    accounts: false,
    betslip: false
  },
  sportsBook: {
    redirectedFromFavorite: false
  },
  casino: {
    casinoElementsCount: 0,
    singleGameViewMounted: false,
    isCasinoCategoriesMounted: false,
    gameClickOffsetTop: null,
    blockCasinoGamePopupOpening: false,
    allGamesCountFetched: false
  },
  tournament: {
    cardClickOffset: 0
  },
  app: {
    messageListenerMounted: false,
    genericMounted: false,
    dayjsLangImported: false,
    configureSpringCalled: false
  },
  isTopNavigationButtonMounted: false,
  homeworkIframe: false,
  oddsFormat: false,
  initProces: false,
  oneTimeCommands: {
    getUserSportOrder: false
  },
  account: {
    registration: {
      automaticSmsCode: false,
      isRecaptchaVerify: false
    }
  }
};

// this is being used from upper module
export const setAppConfigs = (appConfigs: IAppConfigs) => {
  Object.keys(GLOBALS.appConfigs).forEach(
    key => delete GLOBALS.appConfigs[key as keyof IAppConfigs]
  );
  Object.assign(GLOBALS.appConfigs, appConfigs);
};

// this is being used from upper module
export const setLanguageConfigs = (languageConfigs: ILanguageConfigs) => {
  Object.keys(GLOBALS.languageConfigs).forEach(
    key => delete GLOBALS.languageConfigs[key as keyof ILanguageConfigs]
  );
  Object.assign(GLOBALS.languageConfigs, languageConfigs);
};

// this is being used from upper module
export const setCurrentPage = (page: ICurrentPage) => {
  Object.keys(GLOBALS.currentPage).forEach(
    key => delete GLOBALS.currentPage[key as keyof ICurrentPage]
  );
  Object.assign(GLOBALS.currentPage, page);
};

// this is being used from upper module
export const setModuleConfigs = ({
  module,
  configs
}: {
  module: keyof IModuleConfigs;
  configs: Record<string, any>;
}) => {
  Object.keys(GLOBALS.moduleConfigs).forEach(key => {
    if (key === module) {
      delete GLOBALS.moduleConfigs[module];
    }
  });

  if (GLOBALS.moduleConfigs[module] === undefined) {
    GLOBALS.moduleConfigs[module] = {} satisfies ValueOf<IModuleConfigs>;
  }

  // @ts-ignore typescript is not able to understand that module is a key of IModuleConfigs
  Object.assign(GLOBALS.moduleConfigs[module], configs);
};
